import { ENVIRONMENTS } from "../consts/enviroments.consts";

export function isProduction() {
  return process.env.REACT_APP_ENVIROMENT === ENVIRONMENTS.PRODUCTION
}